__turbopack_context__.v({
  "container": "b04mUq_container",
  "shippingMessage": "b04mUq_shippingMessage",
});
